import React from 'react';
import { partnerBenefits } from '../../utils/partnersData';
import { useTranslation } from 'react-i18next';

const PartnersBenefits: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-[#F7F8FA]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold text-[#0F172A] tracking-tight">{t('partnersSection.benefits.title')}</h2>
          <p className="text-[#64748B] mt-3 max-w-xl mx-auto">
            {t('partnersSection.benefits.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {partnerBenefits.map((item, index) => (
            <article
              key={item.title + index}
              className="group bg-white rounded-xl p-6 text-center border border-[#E2E8F0] hover:border-teal-200 hover:shadow-md transition-all duration-300"
            >
              <div className="flex justify-center">
                <div className="relative inline-flex size-12 items-center justify-center rounded-xl bg-gradient-to-br from-teal-50 to-cyan-100 text-teal-700 ring-1 ring-teal-200/70 shadow-sm transition-transform duration-300 group-hover:-translate-y-0.5">
                  <item.icon className="size-6" />
                </div>
              </div>
              <h3 className="font-bold text-[#0F172A] mt-4 text-sm">
                {t(`partnersSection.benefits.items.${index}.title`, { defaultValue: item.title })}
              </h3>
              <p className="text-[#64748B] text-sm mt-2 leading-relaxed">
                {t(`partnersSection.benefits.items.${index}.description`, { defaultValue: item.description })}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersBenefits;
